export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "90%", md: "900px", lg: "1000px" },
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 0,
  maxHeight: "95vh",
  overflowY: "auto",
};

export const headerStyle = {
  bgcolor: "primary.main",
  color: "white",
  p: 3,
  position: "relative",
};

export const contentStyle = {
  p: 4,
};

export const questionBoxStyle = {
  mb: 2,
  border: "1px solid #e0e0e0",
  borderRadius: 1,
  overflow: "hidden",
};

export const questionHeaderStyle = {
  bgcolor: "grey.50",
  px: 2,
  py: 1.5,
  borderBottom: "1px solid #e0e0e0",
  display: "flex",
  alignItems: "center",
  gap: 2,
};

export const questionContentStyle = {
  p: 2,
  bgcolor: "white",
};

export const getEnvRiskLevelColor = (riskLevel) => {
  switch (riskLevel) {
    case "Low":
      return "success";
    case "Medium":
      return "warning";
    case "High":
      return "error";
    case "Very High":
      return "error";
    default:
      return "default";
  }
};

export const environmentalRiskLevels = [
  {
    label: "Low Risk",
    scoreRange: "0-3",
    description:
      "Minimal environmental hazards present. Standard monitoring required.",
  },
  {
    label: "Medium Risk",
    scoreRange: "4-7",
    description:
      "Some environmental concerns identified. Enhanced monitoring and preventive measures needed.",
  },
  {
    label: "High Risk",
    scoreRange: "8-17",
    description:
      "Significant environmental hazards present. Immediate intervention and frequent monitoring required.",
  },
  {
    label: "Very High Risk",
    scoreRange: "18+",
    description:
      "Severe environmental dangers. Urgent action plan and continuous monitoring essential.",
  },
];
